module.exports = __webpack_public_path__ + "media/i.47d1df67.mp3";